export const initHeaderAuthForm = () => {
    const $authRegisterForm = document.querySelector('.js-header-auth-register-form');
    const $authRegisterAction = document.querySelector('.js-header-auth-register');
    const $authRegisterInput = document.getElementById("registerEmailInput");

    const $authLoginForm = document.querySelector('.js-header-auth-login-form');
    const $authLoginActions = document.querySelectorAll('.js-header-auth-login');
    const $authLoginInput = document.getElementById("loginEmailInput");

    const $authPasswordForm = document.querySelector('.js-header-auth-forgot-password-form');
    const $authPasswordAction = document.querySelector('.js-header-auth-forgot-password');
    const $authPasswordInput = document.getElementById("forgotEmailInput");

    if ($authRegisterAction) {
	    $authRegisterAction.addEventListener('click', event => {
			$authLoginForm.classList.remove('form-fade');

			setTimeout(function() {
				$authLoginForm.classList.add('form-hidden');
				$authRegisterForm.classList.remove('form-hidden');

				if (typeof rescaleCaptcha === 'function') {
					rescaleCaptcha();
				}
			}, 150);

			setTimeout(function() {
				$authRegisterForm.classList.add('form-fade');
				$authRegisterInput.focus();
			}, 300);
		})
    }

    if($authLoginActions.length) {
	    $authLoginActions.forEach(el => {
	    	el.addEventListener('click', event => {
				if ($authRegisterForm.classList.contains('form-fade')) {
					$authRegisterForm.classList.remove('form-fade');
				}
				if ($authPasswordForm.classList.contains('form-fade')) {
					$authPasswordForm.classList.remove('form-fade');
				}

				setTimeout(function() {
					if (!$authRegisterForm.classList.contains('form-hidden')) {
						$authRegisterForm.classList.add('form-hidden');
					}
					if (!$authPasswordForm.classList.contains('form-hidden')) {
						$authPasswordForm.classList.add('form-hidden');
					}

					$authLoginForm.classList.remove('form-hidden');
				}, 150);

				setTimeout(function() {
					$authLoginForm.classList.add('form-fade');
					$authLoginInput.focus();
				}, 300);
			})
	 	})
    }

    if ($authPasswordAction) {
		$authPasswordAction.addEventListener('click', event => {
			$authLoginForm.classList.remove('form-fade');

			setTimeout(function() {
				$authLoginForm.classList.add('form-hidden');
				$authPasswordForm.classList.remove('form-hidden');
			}, 150);

			setTimeout(function() {
				$authPasswordForm.classList.add('form-fade');
				$authPasswordInput.focus();
			}, 300);
		})
	}
}
